import React, { lazy } from "react";
import { Route } from "react-router-dom";

const Home = lazy(() => import("scenes/home"));
const Login = lazy(() => import("components/user/Login"));
const Register = lazy(() => import("scenes/user/register"));
const Forbidden = lazy(() => import("scenes/global/forbidden"));
const NotFound = lazy(() => import("scenes/global/notFound"));
const Privacy = lazy(() => import("scenes/global/privacy"));
const Terms = lazy(() => import("scenes/global/terms"));
const Contact = lazy(() => import("scenes/global/contact"));
const About = lazy(() => import("scenes/global/about"));
const Pricing = lazy(() => import("scenes/global/pricing"));
const Leadership = lazy(() => import("scenes/global/leadership"));
const Demo = lazy(() => import("scenes/global/demo"));
const Product = lazy(() => import("scenes/global/product"));
const Status = lazy(() => import("scenes/global/status"));
const FAQ = lazy(() => import("scenes/faq"));

export const publicRoutes = [
  <Route key="home" path="/" element={<Home />} />,
  <Route key="login" path="/login" element={<Login />} />,
  <Route key="register" path="/register" element={<Register />} />,
  <Route key="faq" path="/faq" element={<FAQ />} />,
  <Route key="forbidden" path="/forbidden" element={<Forbidden />} />,
  <Route key="privacy" path="/privacy" element={<Privacy />} />,
  <Route key="terms" path="/terms" element={<Terms />} />,
  <Route key="contact" path="/contact" element={<Contact />} />,
  <Route key="about" path="/about" element={<About />} />,
  <Route key="status" path="/status" element={<Status />} />,
  <Route key="pricing" path="/pricing" element={<Pricing />} />,
  <Route key="leadership" path="/leadership" element={<Leadership />} />,
  <Route key="demo" path="/demo" element={<Demo />} />,
  <Route key="product" path="/product" element={<Product />} />,
  <Route key="not-found" path="*" element={<NotFound />} />,
];

export default publicRoutes;
